export const rxDialogStyles = {
  paper: {
    width: 'calc(100% - 80px)',
    maxWidth: 1240,
    height: 'calc(100vh - 110px)',
    maxHeight: 560,
    minHeight: 500,
    m: 0,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    bgcolor: '#FFFFFF',
    overflow: 'hidden',
    fontFamily: 'Roboto'
  },

  content: {
    flex: '1 1 auto',
    minHeight: 0,
    display: 'flex',
    p: '16px !important',
    bgcolor: '#FFFFFF',
    overflow: 'hidden'
  },
  contentGrid: {
    flex: '1 1 auto',
    width: '100%',
    height: '100%',
    minHeight: 0,
    alignItems: 'stretch'
  },

  gridItem: {
    display: 'flex',
    height: '100%',
    minHeight: 0,
    overflow: 'hidden'
  },

  panel: {
    width: '100%',
    height: '100%',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #E0E0E0',
    borderRadius: '8px',
    bgcolor: '#FFFFFF',
    overflow: 'hidden'
  },

  panelHeader: {
    flexShrink: 0,
    minHeight: 40,
    px: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #E0E0E0',
    bgcolor: '#FAFAFA'
  },

  medicationsScrollArea: {
    flex: '1 1 auto',
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',

    scrollbarWidth: 'none',
    msOverflowStyle: 'none',

    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },

  medicationsTableContainer: {
    width: '100%',
    overflow: 'visible'
  },

  panelTitle: {
    color: '#424242',
    fontSize: 16,
    fontWeight: 500
  },

  tableContainer: {
    flex: '1 1 0',
    height: 0,
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'auto'
  },
  table: {
    width: '100%',
    tableLayout: 'fixed',

    '& .MuiTableCell-root': {
      height: 40,
      px: 2,
      py: 0,
      color: '#424242',
      fontSize: 13,
      borderBottom: '1px solid #E0E0E0'
    }
  },

  inputRow: {
    height: 40,
    bgcolor: '#FFFFFF',
    cursor: 'pointer',

    '&:hover': {
      bgcolor: '#FCF8F2',

      '& .MuiTableCell-root': {
        bgcolor: '#FCF8F2'
      }
    }
  },

  inputCell: {
    px: '6px !important',
    py: '6px !important'
  },

  medicationInput: {
    '& .MuiOutlinedInput-root': {
      height: 40,
      borderRadius: '5px',
      bgcolor: '#FFFFFF',
      fontSize: 13
    },

    '& .MuiInputBase-input': {
      px: 1.5,
      py: 1.25
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#D6D6D6'
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#BDBDBD'
    }
  },

  actionCell: {
    width: 90,
    minWidth: 90,
    px: '8px !important',
    whiteSpace: 'nowrap'
  },

  actionWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.5
  },

  actionButton: {
    width: 30,
    height: 30,
    p: 0
  },

  confirmIcon: {
    color: '#2EAE43',
    fontSize: 22
  },

  clearIcon: {
    color: '#FF3B30',
    fontSize: 22
  },

  editIcon: {
    color: '#757575',
    fontSize: 20,

    '&:hover': {
      color: '#1976D2'
    }
  },

  deleteIcon: {
    color: '#757575',
    fontSize: 20,

    '&:hover': {
      color: '#D32F2F'
    }
  },

  commentsWrapper: {
    p: 2,
    bgcolor: '#FFFFFF'
  },

  commentsInput: {
    '& .MuiOutlinedInput-root': {
      minHeight: 110,
      alignItems: 'flex-start',
      borderRadius: '5px',
      bgcolor: '#FFFFFF',
      fontSize: 13
    },

    '& .MuiInputBase-inputMultiline': {
      p: 0
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#D6D6D6'
    }
  },

  availableTable: {
    width: '100%',
    tableLayout: 'fixed',

    '& .MuiTableCell-root': {
      height: 40,
      px: 1.5,
      py: 0,
      color: '#424242',
      fontSize: 13,
      borderBottom: '1px solid #E0E0E0'
    }
  },

  availableNameCell: {
    width: '52%'
  },

  availableDoseCell: {
    width: '20%',
    textAlign: 'center'
  },

  availableDirectionCell: {
    width: '28%',
    textAlign: 'center'
  },

  medicationNameWrapper: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    gap: 1
  },

  medicationName: {
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },

  selectMedicationButton: {
  width: 26,
  height: 26,
  flexShrink: 0,
  p: 0,
  color: '#4A90D9',
  border: '1px solid #BBDEFB',
  borderRadius: '4px',

  '&:hover': {
    bgcolor: '#EAF4FE',
    borderColor: '#90CAF9'
  }
},

disabledSelectMedicationButton: {
  width: 26,
  height: 26,
  flexShrink: 0,
  p: 0,
  color: '#BDBDBD',
  border: '1px solid #E0E0E0',
  borderRadius: '4px',
  bgcolor: '#F5F5F5',

  '&:hover': {
    bgcolor: '#F5F5F5',
    borderColor: '#E0E0E0'
  },

  '& .MuiSvgIcon-root': {
    color: '#BDBDBD'
  }
},

disabledMedicationRow: {
  pointerEvents: 'none',

  '& .MuiTableCell-root': {
    bgcolor: '#FAFAFA',
    color: '#BDBDBD'
  }
},
  availableMedicationRow: {
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: '#FCF8F2',

      '& .MuiTableCell-root': {
        backgroundColor: '#FCF8F2'
      }
    }
  },

  footer: {
    flexShrink: 0,
    p: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 1,
    borderTop: '1px solid #E0E0E0',
    bgcolor: '#FFFFFF'
  },

  cancelButton: {
    color: '#424242',
    borderColor: '#D8D8D8',
    borderRadius: '4px',
    fontSize: 13,
    fontWeight: 500,
    textTransform: 'uppercase',

    '&:hover': {
      borderColor: '#BDBDBD',
      bgcolor: '#FAFAFA'
    }
  },

  signCloseButton: {
    color: '#424242',
    bgcolor: '#F5DDAE',
    border: '1px solid #E5C481',
    borderRadius: '4px',
    boxShadow: 'none',
    fontSize: 13,
    fontWeight: 500,
    textTransform: 'uppercase',

    '&:hover': {
      bgcolor: '#EFD092',
      boxShadow: 'none'
    }
  },

  signPrintButton: {
    color: '#FFFFFF',
    bgcolor: '#5597D5',
    borderRadius: '4px',
    boxShadow: 'none',
    fontSize: 13,
    fontWeight: 500,
    textTransform: 'uppercase',

    '&:hover': {
      bgcolor: '#4386C5',
      boxShadow: 'none'
    }
  },

  closeIcon: {
    fontSize: 22
  }
};
